import {GetTabNewsForm} from '../../../interfaces/api/tabs';
import {services} from '../../../api';
import {
  GetNewsResponse,
  GetPublisherResponse,
  NewsForm,
} from '../../../interfaces/api/content/news';

/**
 * this function to get recommendation list
 *
 * @return {RecommendationsData | null} recommendation list
 */
export const getNews = async (
  newsForm: NewsForm,
): Promise<GetNewsResponse | null> => {
  try {
    const res = await services.home.getNews(newsForm);
    return res?.content;
  } catch (error: any) {
    return null;
  }
};

/**
 * this function to get Publishers List By Letter
 *
 * @return {any} result of Publishers List
 */
export const getPublishersByLetter = async (
  body: GetTabNewsForm,
): Promise<GetPublisherResponse | null> => {
  try {
    const res = await services.news.getPublishersByLetter(body);
    const data = res?.content?.data.map(i => {
      // @ts-ignore
      return {id: i.name, ...i};
    });
    return {...(res?.content || {}), data};
  } catch (error: any) {
    return null;
  }
};
